import React, { useRef, useEffect, useState } from 'react';

const SectionWrapper = ({ children, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => setIsVisible(entry.isIntersecting));
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px' // Slightly delay showing on scroll
    });

    const currentRef = domRef.current; // Store current ref to avoid issues with cleanup
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={domRef}
      className={`section-padding ${className} fade-in ${isVisible ? 'visible' : ''}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;